import { format } from 'd3-format';

const compactNumber = format('.2~s');

/** Format a number compactly: 1500 → "1.5k", 1000000 → "1M". */
export const formatCompact = (n: number): string =>
  compactNumber(n).replace('G', 'B');

/** Truncate label text used on a horizontal stacked bar's category axis. */
export const truncateLabel = (label: string, max = 10): string =>
  label.length > max ? `${label.slice(0, max)}\u2026` : label;

/** Sum a numeric record's values. Used for stacked totals and donut totals. */
export const sumValues = (record: Record<string, number>): number =>
  Object.values(record).reduce((a, b) => a + b, 0);

/** Stable id builder for SVG `<defs>` / `aria-describedby` references. */
export const buildSvgId = (prefix: string, seed: string): string =>
  `${prefix}-${seed.replace(/[^a-z0-9_-]+/gi, '-')}`;
